
export default {
  name: "VendaIndex",
};
